import { DefaultCompanySortFilter, getSortOption } from "components/filters/Filters/FilterTypes/CompanySortFilterType";
import { type FilterValues } from "components/filters/FilterContext";
import { mapResponseToAddressFilter, mapAddressFilterToInstruction, mapResponseToFunctionGroupsFilter, mapFunctionGroupsFilterToInstruction, mapResponseToKeywordFilter, mapKeywordFilterToInstruction, mapResponseToOnlyMySelectionFilter, mapOnlyMySelectionFilterToInstruction, mapResponseToOwnerFilter, mapOwnersFilterToInstruction, mapResponseToStatusFilter, mapStatusFilterToInstruction, mapResponseToTagFilter, mapTagFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListCompanyInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  tags: mapTagFilterToInstruction(filter.tags),
  address: mapAddressFilterToInstruction(filter.address),
  statuses: mapStatusFilterToInstruction(filter.statuses),
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  functionGroups: mapFunctionGroupsFilterToInstruction(filter.functionGroups),
  // TODO: This can be done better
  order: filter.companySort.sortOption.value,
  onlyMySelection: mapOnlyMySelectionFilterToInstruction(filter.onlyMySelection),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListCompanyFilters,
  values: FilterValues
): Partial<FilterValues> => {
  return {
    keyword: mapResponseToKeywordFilter(response.keyword),
    tags: mapResponseToTagFilter(response.tags, values.tags),
    address: mapResponseToAddressFilter(response.address),
    statuses: mapResponseToStatusFilter(response.statuses, values.statuses),
    owners: mapResponseToOwnerFilter(response.ownerUsers),
    functionGroups: mapResponseToFunctionGroupsFilter(response.functionGroups),
    // TODO: This can be done better
    companySort: {
      sortOption: response.order
        ? getSortOption(response.order)
        : getSortOption(DefaultCompanySortFilter)
    },
    onlyMySelection: mapResponseToOnlyMySelectionFilter(response.onlyMySelection)
  };
};
